// Tracks the products a shopper recently opened (stored locally, newest first).
const KEY = "sn_recent";
const MAX = 12;

export function getRecent() {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
}

export function pushRecent(product) {
  if (!product || !product.id) return;
  try {
    const slim = {
      id: product.id, name: product.name, image: product.image, price: product.price,
      prev_price: product.prev_price, discount: product.discount, rating: product.rating,
      reviews: product.reviews, parish: product.parish, brand: product.brand, sku: product.sku,
      merchant_slug: product.merchant_slug, delivery_days: product.delivery_days,
      is_new: product.is_new, price_on_request: product.price_on_request, finish: product.finish,
    };
    const list = getRecent().filter((x) => x && x.id !== product.id);
    list.unshift(slim);
    localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
    if (product.category) {
      const cv = getCatViews();
      cv[product.category] = (cv[product.category] || 0) + 1;
      localStorage.setItem(CATKEY, JSON.stringify(cv));
    }
  } catch { /* storage full */ }
}

const CATKEY = "sn_cat_views";
export function getCatViews() {
  try { return JSON.parse(localStorage.getItem(CATKEY) || "{}"); } catch { return {}; }
}

export function clearRecent() {
  try { localStorage.removeItem(KEY); } catch { /* ignore */ }
}
